/*
 * @Author: Merlin
 * @Date: 2024-03-11 09:59:26
 * @LastEditors: Merlin
 * @LastEditTime: 2025-06-02 13:32:06
 * @Description: 
 */
export async function Sleep(ms: number) {
    return new Promise((resolve) => setTimeout(resolve, ms));
}


// const {oPromise, resolve, reject} = createPromise();
// const {oPromise, resolve} = createPromise();
// 此为原生方法 Promise.withResolvers() 的手写版 
export function createPromise(){
    let resolve;
    let reject;
    const oPromise = new Promise((f1, f2)=>{
        resolve = f1;
        reject = f2;
    });
    return {
        oPromise,
        promise: oPromise, // 后补，以使此方法与原生方法保持一致 
        resolve,
        reject,
    };
}


/**
 * 加载 echarts（多次调用1次执行）  
 */
export const getEcharts = (()=>{
    let oPromise = {
        promise: null,
        resolve: null,
        reject: null,
    };
    return function () {
        if (oPromise.promise){
            return oPromise.promise;
        }
        Object.assign(oPromise, createPromise());
        const ts01 = Date.now();
        const CDN = useRuntimeConfig().public.CDN;
        let error = null;
        const oProperty = {
            src: CDN.echarts01, /* 此地址已经设为 prefetch  */
            onload(ev) {
                console.log('echarts js loaded. Used ms =', Date.now() -ts01); // ≈ 0.1秒（实测会命中 prefetch 缓存）
                oPromise.resolve(window['echarts']);
            },
            onerror(err) {
                console.log(`echarts js loaded err\n${err?.target?.src}\n`, err);
                if (error) { // 使用判断，以使在 2 次都报错时触发 reject  
                    oPromise.reject(err);
                }
                error = err;
            },
        };
        const oScript01 = Object.assign(document.createElement('script'), {
            ...oProperty,
        });
        const oScript02 = Object.assign(document.createElement('script'), {
            ...oProperty,
            src: CDN.echarts02, /* 此地址已经设为 prefetch  */
        });
        document.head.appendChild(oScript01);
        document.head.appendChild(oScript02);
        return oPromise.promise;
    }
})();

